<template>
	<div class="search">
		<div class="component_search">
			<search-box style="margin:30px auto 0;"></search-box>
		</div>
		<div class="no_searches"  v-if="no_searches">
			<p class="sea_title">未搜索到<span style="color: #EB5336;">“{{wd}}”</span>相关信息</p>
			<div class="no_content">
				<img src="../../assets/public/default@2x.png" alt="">
				<div class="no_text">暂无内容~</div>
				<router-link to="index" class="btn">返回首页</router-link>
			</div>
		</div>
		<div class="search_con" v-else>
			<p class="sea_title">搜索到{{seanum}}条<span style="color: #EB5336;">“{{wd}}”</span>相关信息</p>
			<div class="content_search">
				<div class="book_lists" ref="lists">
					<div class="list" v-for="(item,index) in searchLists" :key="index" :data-id="item.book_id">
						<!-- <div class="image_box" :style="{'background':bgcolor[parseInt(5*Math.random())]}" @click="toBookDetail(item.book_id)"> -->
						<router-link tag="a" :to="{path:'/bookDetail',query:{book_id:item.book_id}}" target="_blank" class="image_box" :style="{backgroundColor:item.background}">
							<div class="book_box">
							<!-- <div class="book_box" @mouseenter="showBig(item.book_id)" @mouseleave="hideBig()"> -->
								<img v-if="item.cover" :src="item.cover" alt="" class="book">
								<img v-else src="../../assets/public/ancientBooks/book.png" alt="" class="book">
								<img src="../../assets/public/shadow_bg@2x.png" alt="" class="shadow">
							</div>
							<transition name="slide-fade">
								<div class="scale_box" v-show="showId==item.book_id">
									<img :src="item.cover" class="book_scale" />
									<img src="../../assets/public/shadow_bg@2x.png" alt="" class="shadow_scale">
								</div>
							</transition>
						</router-link>
						<!-- 书名 -->
						<p class="title" v-html="item.name"></p>
						<!-- 作者 -->
						<div class="author" v-html="item.author"></div>
						<!-- 卷数 -->
						<!-- <div class="remark">{{item.volumes}}</div> -->
					</div>
					<div class="list" style="width: 240px;height: 0"></div>
					<div class="list" style="width: 240px;height: 0"></div>
					<div class="list" style="width: 240px;height: 0"></div>
					<div class="list" style="width: 240px;height: 0"></div>
				</div>
			</div>
			<div class="pagination" v-if="total_pages>1">
				<el-pagination
					@prev-click="handlePre"
					@next-click="handleNext"
					@current-change="changePage"
					:current-page="current_page"
					background
					layout="prev, pager, next"
					:page-size="1"
					:total="total_pages">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import searchBox from '../public/searchBox.vue'
	export default{
		data(){
			return{
				wd:'',
				seanum:0,
				no_searches:false,
				current_page:1,
				input_page:1,
				page_size:12,
				total_pages:null,
				searchLists:null,
				pre_disabled:true,
				next_disabled:false,
				bgcolor:['#E2F9FF','#FFE4E4','#FFF6E4','#F4F4F4','#E4ECFF'],
				showId:null,
			}
		},
		metaInfo: {
			title: '千年医典数据库-科学支撑中医临床、教学科研、健康养生',
			meta: [
				{ name: 'keywords', content: '智能搜索,古籍' },
				{ name: 'description', content: '千年医典数据库的智能搜索' }
			],
		},
		components: {
			searchBox
		},
		created(){
			const hashLocation = this.$route.path
			//   const newLocation = hashLocation.split("#/")[1];
			const url = "https://www.kanguji.com"+hashLocation
			this.$matomo.setCustomUrl(url);//覆盖页面报告的url，可以自定义页面url，加上本页面路由
			//   this.$matomo.trackEvent(shopCode,hashLocation);//事件
			// this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
		},
		mounted(){
			this.wd = this.$route.query.wd
			// console.log(this.$route.query)
			if(this.$route.query.current_page){
				this.current_page = this.$route.query.current_page
			}
			this.getSearchLists()
		},
		methods:{
			getSearchLists(){
				let that = this
				let datas= {
					user_id : that.$store.state.user_id,
					keyword : that.wd,
					page: that.current_page,
					page_size : that.page_size,
				}
				that.$axios.get("book/search",{
					params:datas
				})
				.then((res)=>{
					// console.log(res.data.data.books)
					if(res.data.status_code==200){
						that.searchLists = res.data.data.books
						for(var i = 0; i < that.searchLists.length; i++) {
							var a = parseInt(5 * Math.random())
							that.searchLists[i]["background"] = that.bgcolor[a]
						}
						// that.current_page =res.data.data.current_page
						that. total_pages = res.data.data.total_pages
						that.seanum = res.data.data.total_count
						// 没有搜索结果
						if(that.seanum==0){
							that.no_searches =true
						}else{
							that.no_searches =false
						}
						if(that.current_page==1){
							that.pre_disabled =true
							that.next_disabled =false
						}else if(that.current_page==that.total_pages){
							that.pre_disabled =false
							that.next_disabled =true
						}else{
							that.pre_disabled =false
							that.next_disabled =false
						}
						// window.innerHeight>document.body.clientHeight && (this.$refs.lists.style.minHeight = window.innerHeight-241 +'px')
						// console.log(that.searchLists)
					}else{
						return false;
					}
				})
				.catch(function(err){
					// console.log(err);
					return false;
				})
			},
			 // 点击前一页
			handlePre(val){
				//val是pagination中的第几页
				if(this.current_page>1){
					this.current_page-=1
					this.input_page = this.current_page
					this.getSearchLists()
				}
			},
			// 点击下一页
			handleNext(val){
				if(this.current_page < this.total_pages){
					this.current_page+=1
					this.input_page = this.current_page
					this.getSearchLists()
				}
			},
			changePage(val){
				this.current_page = val
				this.getSearchLists()
			},
			// 到书详情
			toBookDetail(id){
				// this.book_id = e.currentTarget.getAttribute('data-id')
				// this.$router.push({path:'/bookDetail',query:{book_id:id}})	
				let pictureUrl = this.$router.resolve({
					path: "/bookDetail",
					query: {
					book_id: id
					}
				});
				window.open(pictureUrl.href, "_blank");
			},
			showBig(id){
				this.showId = id
			},
			hideBig(){
				this.showId=null
			},
		},
		watch:{
			'$route' (to, from) { //监听路由是否变化
				if(this.$route.query.wd){//判断id是否有值
					//调数据
					this.wd = this.$route.query.wd
					this.current_page = 1
					this.getSearchLists()
				}
			}
		}
	}
</script>

<style scoped lang="scss"  type="text/css">
.search{
	width: 100%;
	background: url(../../assets/public/bg1.png);
	padding-top: 40px;
	padding-bottom: 80px;
	.component_search{
		width:930px;
		margin: -40px auto 50px;
	}
	.search_con{
		width: 1200px;
		/*height: 500px;*/
		margin: 0 auto;
		background: #fff;
		padding: 38px 60px 30px 60px;
		box-sizing: border-box;
		.sea_title{
			font-size: 20px;
			font-weight: 400;
			font-family:PingFangSC-Regular, sans-serif;
		}
		.content_search{
			width: 100%;
			margin-top:-10px;
			.book_lists{
				.list{
					width:240px;
					margin-right: 40px;
					&:nth-child(4),
					&:nth-child(8),
					&:nth-child(12){
						margin-right: 0px;
					}
				}
				
			}
			
		}
		.pagination{
			text-align: center;
			margin:10px auto 30px;
		}
	}
	.no_searches{
		width:1200px;
		height:780px;
		background:#fff;
		margin:0 auto;
		padding-top:35px;
		box-sizing: border-box;
		.sea_title{
			font-size: 20px;
			font-weight: 400;
			font-family:PingFangSC-Regular, sans-serif;
			margin-left:60px;
		}
		.no_content{
			text-align: center;
			img{
				width:569px;
				height:283px;
				margin-top:155px;
			}
			.no_text{
				font-size:16px;
				color:#333;
				line-height: 1;
				margin-top:43px;
				margin-bottom:20px;
				font-family:PingFangSC-Regular, sans-serif;
				font-weight:400;
			}
			.btn{
				display:block;
				margin:0 auto;
				width:103px;
				height:38px;
				line-height:38px;
				border-radius: 19px;
				background:linear-gradient(135deg,rgba(255,124,90,1),rgba(230,82,43,1));
				outline: none;
				color:#fff;
				font-size:14px;
				font-family:PingFangSC-Regular, sans-serif;
				font-weight:400;
				border:none;
			}

		}
		
	}
}
</style>
<style>
em{
	font-style: normal;
	color: #e6522b;
}
/* // 分页 */
.search .pagination {
  margin: 10px auto 50px;
  width: 100%;
  text-align: center;
}
.search .el-pagination.is-background .btn-next,
.search .el-pagination.is-background .btn-prev {
  background: #e6522b !important;
  color: #fff;
  min-width: 50px;
  height: 36px !important;
  line-height: 34px;
  border-radius: 4px;
  margin: 0 20px;
}
.search .el-icon {
  font-size: 14px;
  color: #fff;
}
.search .el-icon:disabled {
  background: #fff;
}
.search .el-icon:disabled .el-icon {
  color: #bfbfbf;
  border: 1px solid #ddd;
  min-width: 50px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}
/* // 中间页码 */
.search .el-pager li {
  min-width: 38px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 19px !important;
  font-size: 16px;
  border: 1px solid #ddd;
  color: #999;
  background-color: #fff !important;
  margin: 0 11px !important;
}
.search .el-pager li:hover {
  background: #e6522b !important;
  color: #fff !important;
  border: 1px transparent;
  line-height: 34px;
}
.search .el-pager li.active {
  background: #e6522b !important;
  color: #fff !important;
  line-height: 34px;
  border: 1px transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/page/search.vue